import React, { useState } from "react";
import LaddaButton from "../../../components/buttons/laddaButton";
import { icons } from "../../../constants";
import EditModal from "./editModal";
import { formatTextWithLineBreaks } from "../../../utils/utilsFunctions";
import { StyledTooltip } from "../../../components/toolltipComponent";
import ModalComponentOpportunityHelp from "../../createOpportunity/modalOpportunityHelp";
import { opportunityHelpIds } from "../../createOpportunity/opportunityHelpData";
import { opportunityState } from "../../../constants/selectData";
import { isRiskVersion } from "../../../utils/riskAndOportunityVersion";
import StrategyRelationsTable from "../../../components/StrategyRelationsTable";
import "../../createOpportunity/styles.css";

const getImpactLabel = (value) => {
  const v = parseInt(value, 10);
  const map = { 1: "Insignificante", 2: "Menor", 3: "Moderado", 4: "Mayor", 5: "Enorme" };
  return map[v] || "";
};

const getProbabilityLabel = (value) => {
  const v = parseInt(value, 10);
  const map = { 1: "Raro", 2: "Improbable", 3: "Posible", 4: "Probable", 5: "Casi seguro" };
  return map[v] || "";
};

const getVulnerabilityLabel = (value) => {
  const v = parseInt(value, 10);
  const map = { 1: "Baja", 3: "Media", 5: "Alta" };
  return map[v] || "";
};

const getOpportunityLevelInfo = (level) => {
  const l = parseInt(level, 10);
  switch (l) {
    case 1:
      return { class: "low-level", textClass: "low-level-text", text: "Oportunidad Bajo" };
    case 2:
      return { class: "medium-level", textClass: "medium-level-text", text: "Oportunidad Medio" };
    case 3:
      return { class: "high-level", textClass: "high-level-text", text: "Oportunidad Alto" };
    case 4:
      return { class: "superior-level", textClass: "superior-level-text", text: "Oportunidad Superior" };
    default:
      return { class: "default-level", textClass: "default-level-text", text: "Sin nivel" };
  }
};

const TabDetails = ({
  data,
  getOpportunityData,
  isEditionAvailable,
  updateRiskupdateDate
}) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
  };
  const handleCloseHelp = () => setOpenHelpModal(false);

  const openModalEditModal = () => {
    setOpenEditModal(true);
  };

  const useVersion2 = isRiskVersion(data?.year, data?.month) === 2;
  const hasNewLevelData =
    data?.vulnerability != null &&
    data?.vulnerability !== "" &&
    data?.impactLevel != null &&
    data?.probability != null;

  const opportunityLevelInfo = hasNewLevelData
    ? getOpportunityLevelInfo(data?.opportunityLevel)
    : null;

  return (
    <div>
      {useVersion2 && (
        <>
          <h2 className="gm-title">Tipo de Oportunidad:</h2>
          <p className="content-text">{data?.riskTypeName ?? "—"}</p>
        </>
      )}
      {!useVersion2 && (
        <>
          <h2 className="gm-title">Estado:</h2>
          <p className="content-text">
            {data?.state != null && data?.state !== ""
              ? opportunityState.find((i) => i.value === parseInt(data.state, 10))?.name
              : ""}
          </p>
        </>
      )}
{/* 
      {hasNewLevelData && opportunityLevelInfo && (
        <div className="IHContainer align-center pillcontainer" style={{ marginBottom: "16px" }}>
          <div className="IHContainer align-center">
            <p className="create-label ml-0">Nivel de oportunidad:</p>
            <div
              className="pointer align-center j-center ml-5"
              onClick={() => setOpenHelpModal(true)}
            >
              <img
                className="btn-add-icon"
                src={icons.infoExclamation}
                alt="icon"
                style={{ margin: "0 0 7px 0", width: "30px" }}
              />
            </div>
          </div>
          <StyledTooltip
            title={
              <>
                <div className="HContainer">
                  <p className="toolkit-title">Impacto:</p>
                  <p className="toolkit-content">{getImpactLabel(data.impactLevel)}</p>
                </div>
                <div className="HContainer">
                  <p className="toolkit-title">Vulnerabilidad:</p>
                  <p className="toolkit-content">{getVulnerabilityLabel(data.vulnerability)}</p>
                </div>
                <div className="HContainer">
                  <p className="toolkit-title">Probabilidad:</p>
                  <p className="toolkit-content">{getProbabilityLabel(data.probability)}</p>
                </div>
              </>
            }
            followCursor
          >
            <div className={`level ${opportunityLevelInfo.class}`}>
              <p className={opportunityLevelInfo.textClass}>{opportunityLevelInfo.text}</p>
            </div>
          </StyledTooltip>
        </div>
      )} */}

      {hasNewLevelData && (
        <ModalComponentOpportunityHelp
          openModal={openHelpModal}
          handleClose={handleCloseHelp}
          helpId={opportunityHelpIds.OPPORTUNITY_LEVEL}
        />
      )}

      <h2 className="gm-title">Descripción:</h2>
      <p className="content-text">
        {formatTextWithLineBreaks(data?.description)}
      </p>
      <h2 className="gm-title">Beneficio:</h2>
      <p className="content-text">{formatTextWithLineBreaks(data?.benefit)}</p>
      <h2 className="gm-title">Plan de Acción:</h2>
      <p className="content-text">
        {formatTextWithLineBreaks(data?.actionPlan)}
      </p>
      <h2 className="gm-title">Impacto:</h2>
      <p className="content-text">{formatTextWithLineBreaks(data?.impact)}</p>
      <h2 className="gm-title">Estrategia {data?.strategyName}:</h2>
      <p className="content-text">
        {formatTextWithLineBreaks(data?.strategyDescription)}
      </p>
      {data?.strategyId && <StrategyRelationsTable strategyId={data.strategyId} />}

      <div className="j-center">
        {isEditionAvailable && (
          <LaddaButton
            variant="contained"
            onClick={() => {
              openModalEditModal();
            }}
          >
            <div className="IHContainer align-rigth">
              <img
                className="btn-icon"
                src={icons.editWhite}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Editar</p>
            </div>
          </LaddaButton>
        )}
      </div>
      <EditModal
        opportunityData={data}
        openEditModal={openEditModal}
        handleCloseEditModal={handleCloseEditModal}
        getOpportunityData={getOpportunityData}
        updateRiskupdateDate={updateRiskupdateDate}
      />
    </div>
  );
};

export { getOpportunityLevelInfo };
export default TabDetails;
